export const NotFound = () => {
  return (
    <div>
        <h1>esta pagina no existe</h1>
    </div>
  )
}

export default NotFound;